<template>
    <div class="row">
        <div class="row">
            <div class="col s12">
                <span id="mensagem-span">{{ mensagem }}</span>
            </div>
        </div>
        <div class="row">
            <div class="col s12">
                <fieldset v-if="sub_options && sub_options.length">
                    <legend>
                        Você pode selecionar entre 1 ou mais elementos:
                    </legend>

                    <base-card v-for="(opt, index) in sub_options" :key="index">
                        <span style="font-size:16px;" slot="title">{{
                            opt.nome
                        }}</span>

                        <span slot="action">
                            <a
                                class="blue-text"
                                @click="marcaComoSelecionado(opt.id)"
                                style="cursor:pointer;"
                            >
                                <i class="material-icons">
                                    add
                                </i>
                            </a>
                        </span>
                    </base-card>
                </fieldset>
                <fieldset
                    v-if="gruposSelecionados && gruposSelecionados.length"
                >
                    <legend>Itens Selecionados</legend>
                    <span>{{ mensagem_itens_selecionados }}</span>
                    <base-card
                        v-for="(grupo, index) in gruposSelecionados"
                        :key="index"
                    >
                        <span slot="title">
                            {{ grupo.nome }}
                        </span>
                        <span slot="action">
                            <a
                                slot="action"
                                class="red-text"
                                @click="desmarcar(grupo.id)"
                            >
                                <i class="material-icons">
                                    clear
                                </i>
                            </a>
                        </span>
                    </base-card>
                </fieldset>
                <fieldset
                    v-if="gruposSelecionados && gruposSelecionados.length"
                >
                    <legend>Naturezas Selecionadas</legend>
                    <div
                        class="input-field col s6 m6 l6 xl6"
                        v-for="(item, index) in gruposSelecionados"
                        :key="index"
                    >
                        <select
                            :id="item.id"
                            class="browser-default"
                            v-model="selectsId[item.id]"
                        >
                            <option disabled>Selecione</option>
                            <option
                                v-for="(i, index) in itensBySubGrupoId(item.id)"
                                :key="index"
                                :value="i.nome"
                            >
                                {{ i.nome }}
                            </option>
                        </select>
                        <label :for="item.id" class="active">{{
                            item.nome
                        }}</label>
                        <div class="input-field col s6 m6 l6 xl6">
                            <a
                                :disabled="disabled"
                                class="waves-effect waves-light btn"
                                @click="addOutro(item.id)"
                                ><i class="material-icons">add</i></a
                            >
                        </div>
                    </div>
                    <div
                        class="input-field col s12 m12 l12 xl12"
                        v-if="mostrarFormNota"
                    >
                        <avaliacao-opcao-outros
                            :item="novoItem"
                            @add-item="addItem"
                            :disabled="!marcouOpcaoOutro"
                        />
                    </div>
                </fieldset>
                <fieldset v-if="itensAvaliados && itensAvaliados.length">
                    <legend>Itens para Avaliação</legend>

                    <div class="input-field col 12 m12 l12 xl12">
                        <base-card
                            v-for="(item, index) in itensAvaliados"
                            :key="index"
                        >
                            <span slot="title">{{ item.nome }}</span>
                            <span slot="descricao">{{ item.nota }}</span>
                            <span slot="action">
                                <a
                                    class="red-text"
                                    @click="removerItemAvaliado(item)"
                                >
                                    <i class="material-icons">
                                        clear
                                    </i>
                                </a>
                            </span>
                        </base-card>
                    </div>

                    <div class="input-field col s2 m2 l2 xl2">
                        <span
                            id="nota-span"
                            name="nota-span"
                            style="font-size:20px;"
                            >Nota:{{ nota }}</span
                        >
                    </div>
                    <div class="input-field col s10 m10 l10 xl10">
                        <button class="btn" @click.prevent="avaliar()">
                            Avaliar
                        </button>
                    </div>
                </fieldset>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import BaseCard from "./BaseCard.vue";
import AvaliacaoOpcaoOutros from "./AvaliacaoOpcaoOutros.vue";
export default {
    props: {
        itens: {
            type: Array,
            required: false
        }
    },
    name: "AvaliacaoArtisticoCulturalOpcaoArtistico",
    components: {
        BaseCard,
        AvaliacaoOpcaoOutros
    },
    data() {
        return {
            itensAvaliados: [],
            gruposSelecionados: [],
            marcouOpcaoOutro: false,
            selectsId: [],
            novoItem: {
                nota_min: 0,
                nota_max: 0,
                nota_var: 0,
                aval_subgrupo_id: 0,
                nome: "",
                nota: 0
            },
            mostrarFormNota: false,
            disabled: false,
            nota: Number
        };
    },
    watch: {
        sub_options: function(newValue, oldValue) {
            this.removerNaturezasDuplicadas();
        },
        gruposSelecionados: function(newValue, oldValue) {
            this.somar();
        },
        itensAvaliados: function(newValue, oldValue) {
            this.somar();
        }
    },
    methods: {
        ...mapActions(["setAvaliacaoArtisticoCultural"]),
        async notaMaxima() {
            try {
                let { data } = await this.$http.get("/api/nova_avaliacao/notaMax/2");
                return data[0].nota_max;
            } catch (error) {
                console.error(error);
            }
        },
        async somar() {
            if (this.itensAvaliados && this.itensAvaliados.length) {
                let notaMaxima = await this.notaMaxima();
                let nota = this.itensAvaliados
                    .map(e => e.nota)
                    .reduce((acc, current) => Number(acc) + Number(current));
                if (nota > notaMaxima) {
                    nota = notaMaxima;
                }
                nota = Number(nota);
                this.$set(this, "nota", nota.toFixed(1));
            }
        },
        removerNaturezasDuplicadas() {
            for (
                let i = 0;
                this.gruposSelecionados && i < this.gruposSelecionados.length;
                i++
            ) {
                let grupo = this.gruposSelecionados[i];
                for (let j = 0; j < this.sub_options.length; j++) {
                    let natureza = this.sub_options[j];
                    if (grupo.nome == natureza.nome) {
                        this.sub_options.splice(j, 1);
                    }
                }
            }
        },
        init() {
            if (
                this.project.avaliacao.avaliacao_artistico_cultural != undefined
            ) {
                this.$set(
                    this,
                    "itensAvaliados",
                    this.project.avaliacao.avaliacao_artistico_cultural
                        .artistico
                );
                this.$set(
                    this,
                    "gruposSelecionados",
                    this.project.avaliacao.avaliacao_artistico_cultural
                        .naturezas_artistico
                );

                this.somar();
            }
        },
        async avaliar() {
            try {
                let artistico = this.itensAvaliados;
                artistico["naturezas"] = this.gruposSelecionados;
                this.setAvaliacaoArtisticoCultural({
                    artistico
                });

                let { data } = await this.$http.post(
                    "/api/avaliacaoArtisticoCultural",
                    {
                        id: this.project.avaliacao.id,
                        avaliacao_artistico_cultural: this.project.avaliacao
                            .avaliacao_artistico_cultural,
                        naturezas_artistico: this.gruposSelecionados,
                        nota: this.nota
                    }
                );
                showMsg(data.msg, 200);
            } catch (error) {
                console.error(error);
            }
        },
        hasItem(item) {
            return this.getItensAvaliadoIndexByNome(item.nome) > -1;
        },
        getItensAvaliadoIndexByNome(nome) {
            if (this.itensAvaliados)
                return this.itensAvaliados.findIndex(
                    e => e.nome.localeCompare(nome) == 0
                );
            else {
                this.$set(this, "itensAvaliados", []);
                return false;
            }
        },
        removerItemAvaliado(item) {
            let itemIndex = this.getItensAvaliadoIndexByNome(item.nome);
            this.itensAvaliados.splice(itemIndex, 1);
        },
        addItem(item) {
            if (this.hasItem(item)) {
                showMsg("Item já incluso!");
            } else {
                this.itensAvaliados.push(item);
                this.somar();
            }
            this.$set(this, "disabled", false);
            this.$set(this, "mostrarFormNota", false);
        },
        addOutro(id) {
            if (
                !this.selectsId ||
                this.selectsId == null ||
                this.selectsId == undefined ||
                !this.selectsId.length
            ) {
                showMsg("Por favor, selecione uma opção");
                return false;
            }
            let item = this.selectsId[id];
            if (item == "Outro (especifique)") {
                this.$set(this, "marcouOpcaoOutro", true);
            } else {
                this.$set(this, "marcouOpcaoOutro", false);
            }
            let itens = this.itensBySubGrupoId(id);
            let newItem = itens.find(e => e.nome.localeCompare(item) == 0);
            this.$set(this, "novoItem", newItem);
            this.$set(this, "mostrarFormNota", true);
            this.$set(this, "disabled", true);
        },
        itensBySubGrupoId(id) {
            return this.itens.filter(e => e.aval_subgrupo_id == id);
        },
        marcaComoSelecionado(id) {
            let itens = [];
            let grupo = this.sub_options.find(e => e.id == id);
            let grupoIndex = this.sub_options.findIndex(e => e.id == id);
            itens = this.options.filter(e => e.aval_subgrupo_id == id);
            grupo.itens = itens;
            if (this.gruposSelecionados === null) {
                this.$set(this, "gruposSelecionados", []);
            }
            this.gruposSelecionados.push(grupo);
            this.sub_options.splice(grupoIndex, 1);
        },
        desmarcar(id) {
            let grupo = this.gruposSelecionados.find(e => e.id == id);
            let index = this.gruposSelecionados.findIndex(e => e.id == id);
            this.gruposSelecionados.splice(index, 1);
            this.sub_options.push(grupo);
            let itens = grupo.itens;
            itens.forEach(element => {
                this.options.push(element);
            });
            delete grupo.itens;
        }
    },
    asyncComputed: {
        sub_options: {
            async get() {
                try {
                    let { data: sub_options } = await this.$http.get(
                        "/api/subgrupos"
                    );
                    return sub_options;
                } catch (error) {
                    console.log(error);
                }
            },
            default: []
        },
        options: {
            async get() {
                try {
                    let { data: options } = await this.$http.get(
                        "/api/grupos/" + 2
                    );
                    return options;
                } catch (error) {
                    console.log(error);
                }
            },
            default: []
        },
        async mensagem() {
            try {
                let { data } = await this.$http.get("/api/mensagens/9");
                return data.mensagem;
            } catch (error) {
                console.error(error);
            }
        },
        async mensagem_itens_selecionados() {
            try {
                let { data } = await this.$http.get("/api/mensagens/10");
                return data.mensagem;
            } catch (error) {
                console.log(error);
            }
        }
    },
    computed: {
        ...mapState(["project"])
    },
    mounted() {
        this.init();
    }
};
</script>
